
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { Bind, Debounce } from 'lodash-decorators'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import type { ClickEvent } from '@xt/client/types/home'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Observer
@Component({
  components: {
    NewSwiper
  }
})
export default class GuildListHeader extends Mixins(MixinsHomeClick) {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  get PageStore() {
    return this.$store.$tonghao
  }

  @Debounce(100, { leading: true, trailing: true })
  @Bind()
  handleOverlap() {
    this.$emit('change-header', window.scrollY < 10)
  }

  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }

  handleToIntro() {
    if (this.PageStore.citiesJsonData?.event) {
      this.onClickEvent(this.PageStore.citiesJsonData.event)
      return
    }
  }

  handleCardClick(item: { cover: string; event?: ClickEvent }) {
    if (item.event) {
      this.onClickEvent(item.event)
      return
    }

    const list = this.PageStore.citiesJsonData?.banner.map(i => i.cover)

    if (!list || !list.length) return

    const index = list.findIndex(i => i === item.cover)

    if (index === -1) return

    this.$showViewer(list, index)
  }

  created(): void {
    /** 外部通过v-if控制组件的显示隐藏，
     * 组件销毁时需要移除事件监听 */
    window.addEventListener('scroll', this.handleOverlap, { passive: true })
    this.$emit('change-header', true) // 切换过来则直接去除背景色
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    window.removeEventListener('scroll', this.handleOverlap)
    this.$emit('change-header', false)
  }
}
